export default __webpack_public_path__ + "static/media/laundry2-beforeB-768w.634cf8e3.png";